import { plainMap } from './plainMap';

export type MapOfLists<K, V> = Map<K, V[]>;

/**
 * Build map of lists by grouping array items using a key-assigning function
 * @param assignKey
 */
const groupArrayBy =
  <K, V>(assignKey: (value: V) => K) =>
  (array: V[]): MapOfLists<K, V> =>
    array.reduce(
      (result, value) => pushMutable(assignKey(value), value)(result),
      new Map(),
    );

const mergeMutable = <K, V>(
  key: K,
  values: V[],
): ((map: MapOfLists<K, V>) => MapOfLists<K, V>) =>
  plainMap.insertOrUpdateMutable(
    key,
    () => values,
    (current) => [...current, ...values],
  );

const pushMutable = <K, V>(
  key: K,
  value: V,
): ((map: MapOfLists<K, V>) => MapOfLists<K, V>) =>
  plainMap.insertOrUpdateMutable(
    key,
    () => [value],
    (current) => [...current, value],
  );

export const mapOfLists = {
  groupArrayBy,
  mergeMutable,
  pushMutable,
};
